import { render } from "./Model3DPreview.vue?vue&type=template&id=ee4bc916&scoped=true&ts=true"
import script from "./Model3DPreview.vue?vue&type=script&lang=ts"
export * from "./Model3DPreview.vue?vue&type=script&lang=ts"

import "./Model3DPreview.vue?vue&type=style&index=0&id=ee4bc916&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee4bc916"]])

export default __exports__